import { useState, useEffect, useRef } from "react";

const HOVER_EVENT_DELAY = 200;
const SWATCH_HOVER_EVENT = "swatch-hover";

const useSwatchHoverEvent = (extractValue) => {
  const [hoveredValue, setHoveredValue] = useState(undefined);
  const timerRef = useRef();

  useEffect(() => {
    const hoverEnter = (params) => {
      const value = extractValue(params);

      if (!value) {
        timerRef.current = setTimeout(() => {
          setHoveredValue(undefined);
        }, HOVER_EVENT_DELAY);
      } else {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
        setHoveredValue(value);
      }
    };

    document.addEventListener(SWATCH_HOVER_EVENT, hoverEnter);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      document.removeEventListener(SWATCH_HOVER_EVENT, hoverEnter);
    };
  }, [extractValue]);

  return hoveredValue;
};

export default useSwatchHoverEvent;
